import EventTypeModel from '../../../models/Maintenance/Event/EventTypeModel';
import BaseStore from '../../BaseStore';

export default class EventTypeStore extends BaseStore {
	constructor(transportLayer) {
    super(EventTypeModel, transportLayer);
  }
};


// WEBPACK FOOTER //
// ./src/stores/Maintenance/Event/EventTypeStore.js